<script>
export default {
  name: 'MultiCamera',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isOpen: true,
      activeItem: {},
      activeIndex: 0,
      container: null,
      contentHeight: 0
    };
  },
  watch: {
    isOpen: {
      handler() {
        this.$emit('open', { open: this.isOpen });
      },
      immediate: false
    }
  },
  computed: {
    getTitle() {
      return this.activeItem.title || this.data[0].title;
    }
  },
  methods: {
    open() {
      this.isOpen = !this.isOpen;
    },
    renderTitle() {
      return (
        <div class="title-wrap">
          <div class="title van-ellipsis">{this.getTitle}</div>
          <div class="action">
            <div class="tip">
              {this.activeIndex + 1}/{this.data.length}
            </div>
            <div class="opt" onclick={this.open}>
              {<van-icon name={this.isOpen ? 'arrow-up' : 'arrow-down'} />}
            </div>
          </div>
        </div>
      );
    },
    renderContent() {
      const list = [];
      this.data.forEach((d, index) => {
        list.push(
          <div class="item" key={index}>
            <div class={{ 'item-inner': true, 'item-inner-active': index === this.activeIndex }}>
              <van-image
                onclick={() => {
                  this.change(d, index);
                }}
                fit="cover"
                width="100%"
                height="100%"
                src={d.stream.poster}
              />
            </div>
          </div>
        );
      });
      return (
        <div class={{ 'content-transtion': true, 'content-transtion-collapse': this.isOpen }}>
          <div class="content-wrap" data-scroll="scroll">
            {list}
          </div>
        </div>
      );
    },
    change(data, index) {
      this.activeItem = data;
      this.activeIndex = index;
      this.$emit('change', data);
    }
  },
  render() {
    // 51 130
    return this.show && this.data.length > 1 ? (
      <div ref="container" class="multi-camera">
        {this.renderTitle()}
        {this.renderContent()}
      </div>
    ) : null;
  },
  mounted() {
    this.container = this.$refs.container;
  }
};
</script>
